import React from 'react'

// The app had no error boundary anywhere: an uncaught exception in any
// component (e.g. while editing a chart's annotations) unmounted the ENTIRE
// React tree, since React walks up to the nearest boundary — or the root,
// if there is none — on an uncaught render/effect error. That's what made
// a bug in one modal look like "the whole viewer/app just closed/went
// blank" instead of a contained, recoverable error.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('Unhandled UI error caught by ErrorBoundary:', error, info?.componentStack)
    }

    handleReload = () => {
        this.setState({ hasError: false })
        window.location.reload()
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '2em', textAlign: 'center' }}>
                    <h2>Something went wrong.</h2>
                    <p>Please reload the page. If this keeps happening, let us know what you were doing right before it broke.</p>
                    <button type='button' className='btn btn-dark text-white' onClick={this.handleReload}>Reload</button>
                </div>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary
